const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getGuestService: (propertyUid, language, nodeType) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/guest_service?language=${language}&property_uid=${propertyUid}&node_type=${nodeType}`,
      })
    ),
};